class Member {
	id = 0;
	oib = null;
	first_name = null;
	last_name = null;
	gender = null;
	date_of_birth = null;
	place_of_birth = null;
	nationality_id = null;
	profession_id = null;
	qualification_id = null;
	academic_title_id = null;
	profession = null;
	occupation = null;
	note = null;
	country_id = null;
	city = null;
	zip_code = null;
	address = null;
	phone_number = null;
	mobile_phone_number = null;
	email = null;
	newsletter_signup = false;
	magazine_country_id = null;
	magazine_city = null;
	magazine_zip_code = null;
	magazine_address = null;
	magazine_note = null;
	company = null;
	company_country_id = null;
	company_city = null;
	company_zip_code = null;
	company_address = null;
	membership_id = null;
	membership_start_date_id = null;
	membership_start_date_value = null;
	reference_number = null;
	membership_type_id = 1;
	membership_special_status_id = null;
	membership_status_id = null;
	branch_id = null;
	magazine_bookstore_delivery = false;
	membership_valid_until_date = null;
	postage_valid_until_date = null;
	membership_paid_until_date = null;
	member_withdrawn = false;
	member_withdrawal_date = null;
	member_deceased = null;
	member_decease_date = null;
	membership_note = null;
	magazine_id = null;
	card_issued = false;
	payment_form_by_email = false;
	payment_note = null;
	withdrawn_books_note = null;
	returned_subscriptions_note = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Member;
